import { highlights } from '@/mocks/home';

export default function Highlights() {
  return (
    <section id="highlights" className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 text-sm font-label font-medium text-primary-700">
            <span className="w-6 h-[2px] bg-primary-500" aria-hidden="true"></span>
            内容类型
          </span>
          <h2 className="mt-4 font-heading font-bold text-2xl md:text-4xl text-foreground-950 leading-snug">
            我们把影像资料整理成四种可用形态
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
            同一个事件，可能同时存在直播录像、网友录屏、现场直拍与截图四种素材。我们按素材可用性分别整理，你想快速了解或深入研究，都能找到合适的入口。
          </p>
        </div>

        <div className="mt-10 md:mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {highlights.map((item, index) => (
            <article
              key={item.id}
              className="group flex flex-col bg-background-50 border border-background-200 rounded-lg p-5 md:p-6 hover:border-primary-300 transition-colors"
            >
              <div className="flex items-center justify-between mb-5">
                <span className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={`${item.icon} text-2xl`} aria-hidden="true"></i>
                </span>
                <span className="font-heading font-bold text-2xl text-background-300 group-hover:text-secondary-300 transition-colors">
                  0{index + 1}
                </span>
              </div>
              <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-950 mb-2.5">
                {item.title}
              </h3>
              <p className="text-sm leading-relaxed text-foreground-600">{item.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}